import { render, staticRenderFns } from "./InvoicesComponent.vue?vue&type=template&id=6484af4f&"
import script from "./InvoicesComponent.vue?vue&type=script&lang=js&"
export * from "./InvoicesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports